module.exports = __webpack_public_path__ + "static/media/Hull colour - light grey RAL 7035 & 3 x pure white RAL 9010 waterlines.8f44e206.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hullColors/Hull colour - light grey RAL 7035 & 3 x pure white RAL 9010 waterlines.jpg
// module id = 44
// module chunks = 0